import React, { Component } from 'react';
import { List, Grid, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

class WhatsappSetPhoneUi extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    callSetPhone = () => {
        console.log("callSetPhone"+this.props.message.key)
        this.props.setPhoneFunction(this.props.message.key)
    }

    render() { 
        return (  
        <div>
            <Button onClick={this.callSetPhone}>{this.props.message.key}</Button> <Link to={'/dashboard/singleOrderView/' + this.props.message.order_num} target="_blank">{this.props.message.order_num}</Link>

            {/* <Link to={'/dashboard/searchReceiptNumber'}>Search For Receipt</Link> */}
            
        </div>
        )
    }
}
 
export default WhatsappSetPhoneUi;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappSetPhoneUi.js